// Add your custom JS here.
jQuery(function ($) {


    if( $('.home').length != 0){
        $('.home #wrapper-navbar').addClass('not-scroll');

    $(window).scroll(function () {
    var height = 150;
    if ($(window).scrollTop() > height) {
      $('.home #wrapper-navbar').removeClass('not-scroll');
    } else {
      $('.home #wrapper-navbar').addClass('not-scroll');
    }
  });
}



  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.section-business, .section-personality, .section-faq').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('animate__animated animate__fadeInLeft animate__fast');
        $(this).find('article').addClass('animate__animated animate__fadeInDown animate__delay-1s animate__fast');
        $(this).next().addClass('animate__animated animate__fadeInRight animate__fast animate__delay-2s');
        $(this).next().find('article').addClass('animate__animated animate__fadeInUp animate__delay-3s animate__fast');

      } 
    });

  }
  else {
    $('.section-business, .section-personality, .section-faq').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('animate__animated animate__fadeInLeft animate__fast');
        $(this).find('article').addClass('animate__animated animate__fadeInDown animate__delay-1s animate__fast');
      } 
    });
    
    
    $('.section-keyword, .section-recruit').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('animate__animated animate__fadeInRight animate__fast');
        $(this).find('article').addClass('animate__animated animate__fadeInUp animate__delay-1s animate__fast');
      } 
    });

    
  }



$('.sec-banner-item').on('inview', function(event, isInView) {
  if (isInView) {
    $(this).addClass('animate__animated animate__fadeInUp  animate__delay-1s');

  } 
});



$(document).click(function(event) {
  if(!$(event.target).closest('#btn-recruit-menu').length) {
    $(".section-recruit").removeClass('open');
  } else {
    $(".section-recruit").addClass('open');
  }
});


$(".pagetop-btn").click(function () {
  var position = 0;
  var speed = 600;
  $("html,body").animate({scrollTop:position},speed);

});


var APP = APP || {};
APP.SEMINAR ={
  init: function(){

    //セミナー日程で絞り込み
    var filter = {
      // setJpValue: function(location,jp_value){
      //   $(location).find('.selected_option').text(jp_value);
      // },
      // setFilter: function(){

      // },

      init: function(){
        var obj_details = $('.select input[type="radio"]:checked');

        obj_details.map(function(e){
          var location = '#'+$(this).prop('name');
          var filter_value =  '.'+$(this).val();
          var jp_value = $(this).closest('label').text();
          //初期値反映
          $(location).find('.selected_option').text(jp_value);
        });

        //変更時
        $('.select input[type="radio"]').on('click',function(){
          var location = '#'+$(this).prop('name');
          var filter_value =  '.'+$(this).val();
          var jp_value = $(this).closest('label').text();

          //日程表示切り替え
          $(location + ' .date_list').children().hide();
          if(filter_value == '.all'){
            $(location + ' .date_list').children().fadeIn();
          }
          else{
            $(location + ' .date_list').children(filter_value).fadeIn();
          }
          //現在選択されている値反映、option非表示
          $(location).find('.selected_option').text(jp_value).toggleClass('options_active');
        });

        //選択肢表示
        $('.selected_option').on('click',function(){
          $(this).toggleClass('options_active');
        });
      },
    };
    filter.init();

  },




};
$(function(){
  APP.SEMINAR.init();
});




});